/**
 * SPEC-70 §2.10 — user-facing scan-failure copy, keyed on the REAL
 * ScanResult.error strings produced by lib/nfc.ts (never throws; resolves
 * {error}) and the iOS bridge ("cancelled", "busy" come through the same
 * channel — NFCBridge.swift:72,116,155,30). Mirrors PASSKEY_LOGIN_ERROR_COPY
 * (DriverLogin.tsx:65-69).
 */
export const NFC_SCAN_ERROR_COPY: Record<string, string> = {
  unsupported: "This device can't scan NFC tags — sign in on the breakroom scanner device.",
  timeout: "Scan timed out — hold the phone to the tag and try again.",
  "nfc permission denied":
    "NFC is disabled for this app — enable it in Settings.",
  "nfc read error": "Couldn't read the tag — hold steady and try again.",
  "scan failed": "Scan failed — hold the phone to the breakroom tag and try again.",
  "invalid UID from scanner":
    "Scan failed — hold the phone to the breakroom tag and try again.",
  "no serial number on tag": "Couldn't read the tag — hold steady and try again.",
  "nfc scan failed": "Scan failed — hold the phone to the breakroom tag and try again.",
  busy: "A scan is already running — try again in a moment.",
  cancelled: "Scan cancelled — try again.",
};

export function nfcScanErrorMessage(error: string): string {
  return NFC_SCAN_ERROR_COPY[error] ?? "Hold your phone to the breakroom tag and try again.";
}
